import { FormControl, MenuItem, Select, SxProps, Tooltip } from '@mui/material';

interface RxLifespanTimeDeltaSelectorProps<T> {
  deltaType: T;
  onChange: (value: T) => void;
  availableOptions?: T[];
  sx?: SxProps;
}

const RxLifespanTimeDeltaSelector = <T extends string>({ deltaType, onChange, availableOptions, sx }: RxLifespanTimeDeltaSelectorProps<T>) => {
  return (
    <FormControl sx={{ margin: '0px', padding: '0px', ...sx }}>
      <Select value={deltaType} onChange={(e) => onChange(e.target.value as T)} sx={{ fontSize: '12px', fontFamily: 'Inter', position: 'relative', margin: '0px', padding: '0px', '.MuiOutlinedInput-notchedOutline': { border: 0, alignItems: "center", } }} size="small" autoWidth>
        <MenuItem value="rxDateToBooking" sx={{ fontSize: '12px', fontFamily: 'Inter' }}>
          Rezeptdatum → Abrechnung
        </MenuItem>
        <MenuItem value="firstTreatmentToBooking" sx={{ fontSize: '12px', fontFamily: 'Inter' }}>
          Erstbehandlung → Abrechnung
        </MenuItem>
        <MenuItem value="lastTreatmentToBooking" sx={{ fontSize: '12px', fontFamily: 'Inter' }}>
          Letzte Behandlung → Abrechnung
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default RxLifespanTimeDeltaSelector;